(() => {
  const ROOT_SELECTOR = '[data-af-section-shop-car-care]';

  const initSection = (root) => {
    const rail = root.querySelector('[data-af-section-shop-car-care-rail]');
    const controls = root.querySelector('[data-af-section-shop-car-care-controls]');
    const prev = root.querySelector('[data-af-section-shop-car-care-prev]');
    const next = root.querySelector('[data-af-section-shop-car-care-next]');

    if (!rail || !controls || !prev || !next) return;
    if (root.dataset.afSectionShopCarCareInitialized === 'true') return;

    const getStep = () => {
      const firstCard = rail.querySelector('.af-section-shop-car-care__stage');
      if (!firstCard) return rail.clientWidth * 0.8;

      const styles = getComputedStyle(rail);
      const gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
      return firstCard.getBoundingClientRect().width + gap;
    };

    const update = () => {
      const desktop = window.matchMedia('(min-width: 990px)').matches;
      const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const scrollable = maxScroll > 2;

      controls.hidden = !desktop || !scrollable;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= maxScroll - 2;
    };

    prev.addEventListener('click', () => {
      rail.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      rail.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    root.dataset.afSectionShopCarCareInitialized = 'true';
    update();
  };

  const init = (scope = document) => {
    if (scope.matches?.(ROOT_SELECTOR)) initSection(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
